// stores/subscriptionListCacheStore.ts

import { create } from 'zustand'
import { persist } from 'zustand/middleware'

type SubscriptionListCreator = {
    coverUrl: string
    avatarUrl: string
    name: string
    handle: string
    isLive: boolean
    isOnline: boolean
    isActive: boolean
    price: number
    save: number
    userId: string
    newPostsCount: number
    expires: string
    billingCycle: string
    monthsSubscribed: number
    renewalPrice: number
    renewDate: string
    lastActivity: string
}

type SubscriptionListCacheState = {
    creatorsByKey: Record<string, SubscriptionListCreator[]>
    setCreators: (key: string, creators: SubscriptionListCreator[]) => void
    getCreators: (key: string) => SubscriptionListCreator[]
    clearCreators: (key: string) => void
}

export const useSubscriptionListCacheStore = create<SubscriptionListCacheState>()(
    persist(
        (set, get) => ({
            creatorsByKey: {},

            setCreators: (key, creators) => {
                set(state => ({
                    creatorsByKey: {
                        ...state.creatorsByKey,
                        [key]: creators
                    }
                }))
            },

            getCreators: key => {
                return get().creatorsByKey[key] ?? []
            },

            clearCreators: key => {
                set(state => {
                    const next = { ...state.creatorsByKey }
                    // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
                    delete next[key]

                    return {
                        creatorsByKey: next
                    }
                })
            }
        }),
        {
            name: 'subscription-list-cache'
        }
    )
)